import { Component, OnInit } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Perfil } from 'src/app/_models/usuario/perfil';
import { PerfilService } from 'src/app/_services/perfil.service';
import { PerfilResponse } from 'src/app/_models/response/perfilResponse';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { BscobrancaTranslate } from 'src/app/_services/bscobrancatranslate';

@Component({
    templateUrl: 'perfil.component.html',
    styleUrls: ['../../../demo/view/tabledemo.scss'],
    styles: [`
        :host ::ng-deep .p-dialog .product-image {
            width: 150px;
            margin: 0 auto 2rem auto;
            display: block;
        }

        @media screen and (max-width: 960px) {
            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:last-child {
                text-align: center;
            }

            :host ::ng-deep .p-datatable.p-datatable-customers .p-datatable-tbody > tr > td:nth-child(6) {
                display: flex;
            }
        }

    `],
    providers: [MessageService, ConfirmationService]
})

export class PerfilComponent implements OnInit {

    perfilDialog: boolean;
    perfis: Perfil[];
    perfil: Perfil;
    selectedPerfis: Perfil[];
    submitted: boolean;
    cols: any[];

    perfilCont: Perfil;
    manterPerfil: string;
    labelHeader: string;

    constructor(private perfilService: PerfilService, private messageService: MessageService,
                private confirmationService: ConfirmationService, private breadcrumbService: AppBreadcrumbService,
                private authenticationService: AuthenticationService,
                private bscobrancaTranslate: BscobrancaTranslate) {
        this.manterPerfil = this.bscobrancaTranslate.getText('menu.manterPerfil');
        this.labelHeader = this.bscobrancaTranslate.getText('menu.administracao');
        this.breadcrumbService.setItems([
            { label: this.labelHeader },
            { label: this.manterPerfil, routerLink: ['/administracao/perfil/perfil'] }
        ]);
    }

    ngOnInit(): void {
        this.perfilService.getAll().toPromise().then(data => this.perfis = data);
        this.perfilCont = this.authenticationService.atualUserPerfilValue;
        this.cols = [
            { field: 'codPerfil', header: 'Codigo Banco' },
            { field: 'dscPerfil', header: 'Descrição Perfil' },
            { field: 'nmePerfil', header: 'Nome Perfil' }
        ];
    }

    openNew() {
        this.perfil = {};
        this.submitted = false;
        this.perfilDialog = true;
    }

    deleteSelectedPerfis() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.perfis = this.perfis.filter(val => !this.selectedPerfis.includes(val));
                this.selectedPerfis = null;
                this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'Banco Exclu\u00EDdo', life: 3000 });
            }
        });
    }

    editPerfil(perfil: Perfil) {
        this.perfil = { ...perfil };
        this.perfilDialog = true;
    }

    deletePerfil(perfil: Perfil) {
        this.confirmationService.confirm({
            message: this.bscobrancaTranslate.getText('mensagens.perfil-001') + perfil.nmePerfil + '?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.perfilService.deletar(perfil).subscribe(
                    (perfilResponse: PerfilResponse) => {
                        if (perfilResponse) {
                            if (perfilResponse.codigo === 0) {
                                this.perfis = this.perfis.filter(val => val.codPerfil !== perfil.codPerfil);
                                this.perfil = {};
                                this.messageService.add({ severity: 'success', summary: 'Successful',
                                detail: this.bscobrancaTranslate.getText('mensagens.perfil-002'), life: 3000 });
                            } else {
                                this.messageService.add({ severity: 'error', summary: 'Error', detail: perfilResponse.mensagem,
                                life: 3000 });
                            }
                        } else {
                            this.messageService.add({
                                severity: 'error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.perfil-003'),
                                life: 3000
                            });
                        }
                    });
            }
        });
    }

    validatePerfil() {
        if (!this.perfil.nmePerfil) {
            return this.bscobrancaTranslate.getText('mensagens.perfil-004');
        }
        if (!this.perfil.dscPerfil) {
            return this.bscobrancaTranslate.getText('mensagens.perfil-005');
        }
        return '';
    }

    savePerfil() {
        this.submitted = true;
        const error = this.validatePerfil();
        if (error !== '') {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 });
        } else {
            if (this.perfil.nmePerfil.trim()) {
                if (this.perfil.codPerfil != null) {
                    console.log(this.perfil);
                    this.perfilService.atualizar(this.perfil).subscribe(
                        (perfilResponse: PerfilResponse) => {
                            if (perfilResponse) {
                                if (perfilResponse.codigo === 0) {
                                    this.perfis[this.findIndexById(perfilResponse.perfil.codPerfil)] = perfilResponse.perfil;
                                    this.messageService.add({
                                        severity: 'success', summary: 'Successful', detail: this.bscobrancaTranslate.getText('mensagens.perfil-006'),
                                        life: 3000
                                    });
                                    this.perfilService.getAll().toPromise().then(data => this.perfis = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: perfilResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'Error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.perfil-007'),
                                    life: 3000
                                });
                            }
                        });
                }
                else {
                    this.perfilService.inserir(this.perfil).subscribe(
                        (perfilResponse: PerfilResponse) => {
                            if (perfilResponse) {
                                if (perfilResponse.codigo === 0) {
                                    this.perfis.push(perfilResponse.perfil);
                                    this.messageService.add({ severity: 'success', summary: 'Successful',
                                    detail: this.bscobrancaTranslate.getText('mensagens.perfil-008'), life: 3000 });
                                    this.perfilService.getAll().toPromise().then(data => this.perfis = data);
                                } else {
                                    this.messageService.add({ severity: 'error', summary: 'Error', detail: perfilResponse.mensagem,
                                    life: 3000 });
                                }
                            } else {
                                this.messageService.add({
                                    severity: 'Error', summary: 'Error', detail: this.bscobrancaTranslate.getText('mensagens.perfil-009'),
                                    life: 3000
                                });
                            }
                        });
                }

                this.perfis = [...this.perfis];
                this.perfilDialog = false;
                this.perfil = {};
            }
        }
    }

    hideDialog() {
        this.perfilDialog = false;
        this.submitted = false;
    }

    findIndexById(id: number): number {
        let index = -1;
        for (let i = 0; i < this.perfis.length; i++) {
            if (this.perfis[i].codPerfil === id) {
                index = i;
                break;
            }
        }
        return index;
    }


}

